import { FlagPlusIcon } from './FlagPlusIcon';

/**
 * author: Michael Richins
 * id EF2E3070-75EC-44C3-9ECE-780BB330D51B
 * name flag-plus
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-plus.svg
 * tags
 */
export const FlagAddIcon = FlagPlusIcon;
export default FlagAddIcon